import React from 'react';
import { ApplicationState } from 'reducers';
import { connect, DispatchProp } from 'react-redux';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { withRouter, RouteComponentProps } from 'react-router';
import { UserAllDataFragment } from '@api/graphql/types';
import { logoutAction } from '@actions/authActions';
import { Link } from 'react-router-dom';
import ModuleConfig from '@modules/ModuleConfig';


type Props = {
    user: UserAllDataFragment | null,
    permissions: string[] | null,
} & DispatchProp<any> & RouteComponentProps & InjectedIntlProps;

export interface NavLink {
    label: string;
    path?: string;
    roles?: string[];
    onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
    icon: string;
    subMenus?: NavLink[];
}

interface State {
    displayDropDown: boolean;
}

class Navigation extends React.Component<Props, State> {
    public state = {
        displayDropDown: false,
    };

    private links: NavLink[] = [
        ...ModuleConfig.menu,
    ];

    private renderNavLink = (link: NavLink) => {
        const { intl } = this.props;
        // @ts-ignore
        if (link.roles && !link.roles.every(role => this.props.permissions.includes(role))) {
            return null;
        }
        if (link.path) {
            return (
                <Link to={link.path} onClick={link.onClick}>
                    <i className={`fa ${link.icon}`}/>
                    <span className="nav-label">{intl.formatMessage({ id: `module.${link.label}.${link.label}`})}</span>
                </Link>
            );
        }

        if (link.onClick) {
            return (
                <a onClick={link.onClick}>
                    <i className={`fa ${link.icon}`}/>
                    <span className="nav-label">{intl.formatMessage({ id: link.label })}</span>
                </a>
            );
        }
        console.warn('missing onClick & path');
        return null;
    }

    private renderNavSubLink = (link: NavLink) => {
        const { intl } = this.props;
        // @ts-ignore
        if (link.roles && !link.roles.every(role => this.props.permissions.includes(role))) {
            return null;
        }
        if (link.path) {
            return (
                <Link to={link.path} onClick={link.onClick}>
                    {intl.formatMessage({ id: `module.${link.label}.${link.label}`})}
                </Link>
            );
        }

        if (link.onClick) {
            return (
                <a onClick={link.onClick}>
                    {intl.formatMessage({ id: link.label })}
                </a>
            );
        }
        console.warn('missing onClick & path');
        return null;
    }

    private renderNavParentLink = (link: NavLink, isActive: boolean) => {
        if (!link.subMenus) {
            return this.renderNavLink(link);
        }

        const activeSubmenus: NavLink[] = [];
        link.subMenus.forEach((submenu): void => {
            if (!submenu.roles) {
                activeSubmenus.push(submenu);
            }
            if (this.props.permissions && submenu.roles!.every((role) => this.props.permissions!.includes(role))) {
                activeSubmenus.push(submenu);
            }
        });

        if (!activeSubmenus.length) {
            return null;
        }

        const { intl } = this.props;

        if (activeSubmenus[0].path) {
            return (
                <>
                    <Link to={activeSubmenus[0].path} onClick={activeSubmenus[0].onClick}>
                        <i className={`fa ${link.icon}`}/>
                        <span className="nav-label">{intl.formatMessage({ id: `menu.${link.label}`})}</span>
                    </Link>
                    <ul className={`nav nav-second-level collapse ${isActive ? 'in' : ''}`} aria-expanded={isActive}>
                        {link.subMenus.map((l) => {
                            const isSubActive = l.path && this.props.history.location.pathname.split('/')[2] === l.path.split('/')[2];
                            return (
                                <li key={l.path + l.label} className={isSubActive ? 'active' : ''}>
                                    {this.renderNavSubLink(l)}
                                </li>
                            );
                        })}
                    </ul>
                </>
            );
        }

        if (activeSubmenus[0].onClick) {
            return (
                <>
                    <a onClick={activeSubmenus[0].onClick}>
                        <i className={`fa ${link.icon}`}/>
                        <span className="nav-label">{intl.formatMessage({ id: `menu.${link.label}`})}</span>
                    </a>
                    <ul className="nav nav-second-level collapse in">
                        {link.subMenus.map((l) => {
                            const isSubActive = l.path && this.props.history.location.pathname.split('/')[2] === l.path.split('/')[2];
                            return (
                                <li key={l.path + l.label} className={isSubActive ? 'active' : ''}>
                                    {this.renderNavLink(l)}
                                </li>
                            );
                        })}
                    </ul>
                </>
            );
        }
        console.warn('missing onClick & path');
        return null;
    }

    public render () {
        const { children, user } = this.props;
        if (!user) {
            return children;
        }

        return (
            <nav className="navbar-default navbar-static-side" role="navigation">
                <div className="sidebar-collapse">
                    <ul className="nav metismenu" id="side-menu">
                        <li className="nav-header">
                            <div className="dropdown profile-element">
                                <img alt="image" className="rounded-circle" src="/images/groby_logo_white.svg" style={{width: '100%', marginBottom: '20px'}} />
                                <a data-toggle="dropdown" className="dropdown-toggle" onClick={() => { this.setState({displayDropDown: !this.state.displayDropDown}); }}>
                                    <span className="clear">
                                        <span className="block m-t-xs">
                                            <strong>{user.name}</strong>
                                        </span>
                                        <span className="text-muted text-xs block">
                                            {user.email}
                                            <b className="caret" />
                                        </span>
                                    </span>
                                </a>
                                <ul className={`dropdown-menu animated fadeInRight m-t-xs ${this.state.displayDropDown && 'show'}`} x-placement="bottom-start" style={{position: 'absolute', top: '91px', left: '0px', willChange: 'top, left'}}>
                                    <li><a className="dropdown-item" onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
                                        event.preventDefault(); this.props.dispatch(logoutAction());
                                    }}>{this.props.intl.formatMessage({ id: 'logout' })}</a></li>
                                </ul>
                            </div>
                        </li>
                        {this.links.map((link) => {
                            const isActive = link.path && this.props.history.location.pathname.split('/')[1] === link.path.split('/')[1];

                            return (
                                <li key={link.path + link.label} className={isActive ? 'active' : ''}>
                                    {link.subMenus ? this.renderNavParentLink(link, isActive || false) : this.renderNavLink(link)}
                                </li>
                            );
                        })}
                    </ul>
                </div>
            </nav>
        );
    }
}


const mapStateToProps = ({ auth }: ApplicationState) => {
    return {
        user: auth.user,
        permissions: auth.permissions,
    };
};

export default withRouter(injectIntl(connect(mapStateToProps)(Navigation)));



// WEBPACK FOOTER //
// ./src/components/Navigation.tsx